import { createSlice } from "@reduxjs/toolkit";
import { initialOperationalUpdatesState } from "./operationalUpdates.types";
import { LoadState } from "../../constants/enums";
import { fetchOperationalUpdatesList } from "./operationalUpdatesThunk";


const operationalUpdatesSlice = createSlice({
  name: "operationalUpdates",
  initialState: initialOperationalUpdatesState,
  reducers: {
       clearOperationalUpdatesState: (state) => {
      state.list = [];
      state.loading = LoadState.NotLoaded;
    },
  },
  extraReducers: (builder) => { 
    builder.addCase(fetchOperationalUpdatesList.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.list = [];
    });
    builder.addCase(fetchOperationalUpdatesList.fulfilled, (state, action) => {

      state.list = action.payload.data;
      state.loading = LoadState.Loaded;
    });
    builder.addCase(fetchOperationalUpdatesList.rejected, (state) => {
      state.loading = LoadState.Failed;
      state.list = [];
    }); 
  }});

  export const { clearOperationalUpdatesState } = operationalUpdatesSlice.actions;

export const  operationalUpdatesReducer = operationalUpdatesSlice.reducer;